module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image17-7c11f0b147c9d5031343d7235f812608.jpg";